import { boardPresets, BoardPresets } from 'modules/template-editor/domain/consts/form/boards/boardPresets';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'ud-ui/components/modal';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { deleteBoard } from 'modules/template-editor/store/templates/actions';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useBoards from 'modules/template-editor/ui/hooks/use-boards';

const PRESET = BoardPresets.delete;

function useDeleteModal() {
  const dispatch = useDispatch();
  const { activeBoard, isProcessed, isFinished, process } = useBoards();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    if (!activeBoard) return;
    dispatch(deleteBoard({ id: activeBoard.id }));
  }, [activeBoard, dispatch]);

  // const data: IUNModalProps = useMemo(() => {
  //   return {
  //     initialValue: {},
  //     headerText: 'Удаление табло',
  //     contentText: 'Вы уверены, что хотите удалить этот табло? Это действие нельзя отменить.',
  //     buttonText: 'Удалить',
  //     onSubmit,
  //     isProcessed,
  //   };
  // }, [isProcessed, onSubmit]);

  // const { modal, close, open } = useUniversalModal(data);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (process !== 'delete board') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [close, dispatch, isFinished, process]);

  return {
    modal: (
      <Modal show={isOpen} onClose={close}>
        <Modal.Header title={boardPresets[PRESET].header} />
        <Modal.Body>
          <UDText variant="text-2">Вы уверены, что хотите удалить это табло?</UDText>
          <UDText variant="text-2">Это действие нельзя отменить.</UDText>
        </Modal.Body>
        <Modal.Footer className="w-[400px]">
          <UDButton variant="secondary" type="button" onClick={close} loading={isProcessed} stretch>
            Отмена
          </UDButton>
          <UDButton variant="primary" type="button" onClick={onSubmit} loading={isProcessed} stretch>
            {boardPresets[PRESET].submitButton}
          </UDButton>
        </Modal.Footer>
      </Modal>
    ),
    close,
    open,
  };
}

export default useDeleteModal;
